/**
 * Filter bar for the audit table.
 *
 * Layout: [Search input] [Rooftop ▾] [Condition ▾] [Flag ▾]
 *
 * Hidden entirely on Dealer Duplicates sheet (no filters defined for it).
 * Uses filter options from AuditContext (loaded per run + sheet).
 */
import React from "react"

import { useAudit } from "../../context/AuditContext"
import { THEME } from "../../config/theme"
import MultiSelectDropdown from "./MultiSelectDropdown"
import SearchInput from "./SearchInput"

export default function FilterBar() {
  const {
    currentSheet,
    filters,
    setFilter,
    search,
    setSearch,
    filterOptions,
    filterOptionsLoading,
  } = useAudit()

  // Hide entirely on Dealer Duplicates
  if (currentSheet === "dealer_duplicates") {
    return null
  }

  const containerStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: THEME.spacing.sm,
    padding: `${THEME.spacing.sm} 0`,
    flexWrap: "wrap",
  }

  return (
    <div style={containerStyle}>
      <SearchInput
        value={search}
        onChange={setSearch}
        placeholder="Search VIN, stock, make, model..."
      />
      <MultiSelectDropdown
        label="Rooftop"
        options={filterOptions?.rooftops ?? []}
        selected={filters.rooftop}
        onChange={(values) => setFilter("rooftop", values)}
        disabled={filterOptionsLoading}
      />
      <MultiSelectDropdown
        label="Condition"
        options={filterOptions?.vehicle_types ?? []}
        selected={filters.vehicle_type}
        onChange={(values) => setFilter("vehicle_type", values)}
        disabled={filterOptionsLoading}
      />
      <MultiSelectDropdown
        label="Flag"
        options={filterOptions?.flag_types ?? []}
        selected={filters.flag_type}
        onChange={(values) => setFilter("flag_type", values)}
        disabled={filterOptionsLoading}
        align="right"
      />
    </div>
  )
}
